import { 
  Component, 
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';

import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_owner_creation_form_ComponentContextService } from './FootprintManager.owner_creation_form.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Owners_owner_project_statuses_dd_singleComponent } from './Owners.owner_project_statuses_dd_single.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Owners_owner_project_statuses_dd_singleComponent),
  ],
  selector: 'FootprintManager-owner_creation_form',
  templateUrl: './FootprintManager.owner_creation_form.component.html'
})
export class FootprintManager_owner_creation_formComponent extends BaseComponent implements OnInit, OnDestroy {


  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  outParams: { confirm?: boolean, ownerId?: number, reason?: string } = { confirm: null, ownerId: null, reason: null };
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { nextId?: number } = { };
  //#endregion
  //#region Events
  @Output()
  outParamsChange = new EventEmitter<{ confirm?: boolean, ownerId?: number, reason?: string }>();
  
  events = {
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  formGroup: FormGroup = new FormGroup({
    lookupcode: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    status: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    name: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    notes: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
      confirm: new ToolModel(new ButtonModel('confirm', new ButtonStyles(['primary'], null), false, false, false, 'Save', '', null)
    , false),
      cancel: new ToolModel(new ButtonModel('cancel', new ButtonStyles(['secondary'], null), false, false, false, 'Cancel', '', null)
    , false)
  };

  fields = {
    lookupcode: new FieldModel(new TextBoxModel(this.formGroup.controls['lookupcode'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Owner code', true, false),
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Status', true, false),
    name: new FieldModel(new TextBoxModel(this.formGroup.controls['name'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Name', true, false),
    notes: new FieldModel(new TextBoxModel(this.formGroup.controls['notes'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Notes', false, false),
  };

  fieldsets = {
    newGroup1: new FieldsetModel(
      '',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $form = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

  //#region fields inParams
  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
    lookupcode: this.fields.lookupcode.control.valueChanges
    ,
    status: this.fields.status.control.valueChanges
    ,
    name: this.fields.name.control.valueChanges
    ,
    notes: this.fields.notes.control.valueChanges
    ,
  }
  

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_owner_creation_form_ComponentContextService,
) { 
    super();
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'New owner';
  
    const $form = this;
    const $utils = this.$utils;

    
    (this.fields.status.control as SelectBoxModel).reset(1);
    
    

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.$formGroupFieldValidationObservables
      .lookupcode
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .status
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .name
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .notes
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $form: FootprintManager_owner_creation_formComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owner_creation_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $form.outParams.confirm = false;
  
  const nextId = (await $flows.Utilities.reserve_nextId_flow({ entity: 'Owner' })).nextId;
  $form.vars.nextId = nextId;
  }
  on_confirm_clicked(event = null) {
    return this.on_confirm_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_confirm_clickedInternal(
    $form: FootprintManager_owner_creation_formComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owner_creation_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $form.toolbar.confirm.control.readOnly = true;
  
  
  // Check required fields
  const allRequiredFieldHaveValue = $utils.isAllDefined(
      $form.fields.lookupcode.control.value,
      $form.fields.name.control.value,
      $form.fields.status.control.value
  );
  
  if (!allRequiredFieldHaveValue) {
      $form.toolbar.confirm.control.readOnly = false;
      $shell.Owners.openErrorDialog('Owner Creation Error', 'Please enter in data in all required fields.');
      return;
  }
  // Check for owner duplicates
  const owners = (await $datasources.Owners.ds_get_owner_by_lookupcode.get({ lookupcode: $form.fields.lookupcode.control.value })).result;
  if ($utils.isDefined(owners)) {
      $form.toolbar.confirm.control.readOnly = false;
      $shell.Owners.openErrorDialog('Owner Creation Error', 'Owner lookupcode already exists.');
      return;
  
  }
  
  // Create owner and project
  
  const owner_payload = {
  
      "Id": $form.vars.nextId,
      "EnterpriseId": 1,
      "StatusId": $form.fields.status.control.value,
      "LookupCode": $form.fields.lookupcode.control.value,
      "Name": $form.fields.name.control.value,
      "Notes": $form.fields.notes.control.value,
      "MobileAutoPopulateActualQuantityOnPickTask": false,
      "MobileAutoPopulateActualQuantityOnManufacturingMoveTask": false,
      "MobilePickingRequireMaterialUPCScan": false,
      "MobilePickingIncrementQuantityDuringMaterialUpcScaning": false,
      "MobilePickingAutoSelectNextSequentialPickTask": false,
      "MobilePickingAutoSelectNextSequentialClusterPickTask": false,
      "MobilePickingAutoPopulateTargetLicensePlate": false,
      "MobileAutoPopulateBatchMovesTargetLocation": false,
      "MobileAutoPopulateReplenishmentTargetLocation": false,
      "MobileClearReceiptNumberOnPartialReceipts": false,
      "MobileDefaultCursorIntoReceiptNumberDuringInitialReceiving": false,
      "DefaultReceivingQuantityToMaterialPalletHighAndTieCalculation": false,
      "DisableWaveValidation": false,
      "MobilePutAwayIncrementQuantityDuringMaterialUpcScaning": false,
      "MobileReceivingMustUpdateSerialNumber": false,
      "MobileLpMoveIncrementQuantityDuringMaterialUpcScaning": false,
      "EPortalRejectOutboundOrderCreationIfNotEnoughAvailableInventory": false,
      "MobilePickingRequireLotScan": false,
      "MobileCountBackRequired": false,
      "MobilePackingIncQtyInMaterialUpcScan": false,
      "MobilePackingRestrictManualSelectMaterialViaF4": false,
      "MobilePickingShowReportingPackaging": false,
      "MobilePickingAutoSelectPickSlipOnSingleFound": false,
      "MobilePickingSkipSourceLooseLocationScanning": false,
      "MobileBlindReceivingAutoGenerateLicensePlate": false,
      "MobileInventoryMoveRequireMaterialUPCScan": false,
      "MobileInventoryMoveIncrementQuantityDuringMaterialUpcScaning": false,
      "MobileManufacturingOrdersInventoryMoveRequireMaterialUPCScan": false,
      "MobileManufacturingOrdersInventoryMoveIncrementQuantityDuringMaterialUpcScaning": false,
      "MobileReplenishmentRequireMaterialUPCScan": false,
      "MobileReplenishmentIncrementQuantityDuringMaterialUpcScaning": false,
      "MobileBatchMoveRequireMaterialUPCScan": false,
      "MobileBatchMoveIncrementQuantityDuringMaterialUpcScaning": false,
      "MobilePickingAutoConfirmAndLoad": false,
      "MobileFullLpPickingAutoConfirmAndLoad": false,
      "MobilePickingIncrementQuantityDuringLotScan": false,
      "DesctopManufacturingFeedbackAutoGenerateLp": false,
      "MobilePickRequireLocationScan": false,
      "MobilePickingDoNotChangeTargetLPWhenShipmentIsCartonized": false,
      "MobileReceivingRequireSelectPackaging": false,
      "MobilePickingAutoSelectNextSequentialManualAllocation": false,
      "MobileReceivingQuantiyOnlyFromParser": false
  }
  
  let versionCheck = await $flows.Utilities.check_footprint_version({ minimumVersion: '24.08.23' });
  
  if (versionCheck.meetsMinimumVersion) {
      owner_payload["DesktopManufacturingFeedbackLockdownStagingLocation"] = false;
  }
  
  
  const payload = {
      "OwnerId": $form.vars.nextId,
      "LookupCode": $form.fields.lookupcode.control.value,
      "Name": $form.fields.name.control.value,
      "StatusId": $form.fields.status.control.value,
      "IsDefault": true,
      "AllowOneSerialScanForFullLpPick": false,
      "ControlledByGlobalMaterialCatalogs": false,
      "ByPassAutoSelectSerialNumbersRestriction": false,
      "ByPassShowSerialNumbersRestriction": false,
      "ByPassReverseSelectSerialNumbersRestriction": false,
      "MobileUseNonBlockingPickConfirmation": false,
      "MobilePickSlipSearchMask": 2047,
      "ReceivingAutoCreateSerialSuppressScreen": false,
      "PickingAutoSelectSerialSuppressScreen": false,
      "NewOrderApprovalRequired": false,
      "AllowMultipleShippingLpsPerShippingContainer": false,
      "SuppressBatchLoading": false,
      "SkipAdjustmentWhenPicking": false,
      "MobileRequireLicensePlateMoveBlindCount": false,
      "MobileHideTotalOnSerialNumberSelection": false,
      "HandleContainerCode": false
  }
  
  try {
      const owner_create = (await $flows.Utilities.crud_create_flow({ entitySet: 'Owners', entity: owner_payload }));
      let owner_reason = owner_create.reason;
      if ($utils.isDefined(owner_reason)) {
          addReason(owner_reason);
          $shell.Utilities.openErrorDialog('Unable to create owner.', owner_reason);
          $form.toolbar.confirm.control.readOnly = false;
  
      }
      else {
  
          const create = (await $flows.Utilities.crud_create_flow({ entitySet: 'Projects', entity: payload }));
          let reason = create.reason;
  
          if ($utils.isDefined(reason)) {
              addReason(reason);
              $shell.Utilities.openErrorDialog('Unable to create default project.', reason);
              $form.toolbar.confirm.control.readOnly = false;
  
          }
  
          else {
  
              $form.outParams.confirm = true;
              $form.outParams.ownerId = $form.vars.nextId;
              $form.close();
  
          }
      }
  
  
  }
  
  catch (error) {
  
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      addReason(errorMessage);
      $form.toolbar.confirm.control.readOnly = false;
  }
  
  
  //** FUNCTIONS */
  function addReason(reason: string) {
      if (!$utils.isDefined($form.outParams.reason)) {
          $form.outParams.reason = '';
      }
      $form.outParams.reason += reason + ' ';
  }
  }
  on_cancel_clicked(event = null) {
    return this.on_cancel_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_clickedInternal(
    $form: FootprintManager_owner_creation_formComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_owner_creation_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $form.outParams.confirm = false;
  $form.close();
  }
  //#endregion private flows
}
